import { Icon } from '@chakra-ui/react';

export const ChevronDownIcon = (props: any) => (
  <Icon aria-label="chevron down icon" {...props}>
    <path
      d="m12 10 3.5 4h-7z"
      transform="rotate(180,12,12)"
      fill="currentColor"
    />
  </Icon>
);
